import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LinkButtonComponent } from '../link-button/link-button.component';
import { ButtonLinkConfig } from '@/app/models/button-link.model';
import { MixPanelEvent } from '@/app/services/mixpanel.service';

@Component({
  selector: 'dr-flex-home-ui-widget-header',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterModule, LinkButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './widget-header.component.html',
  styleUrl: './widget-header.component.scss',
})
export class WidgetHeaderComponent {
  title = input.required<string>();
  link = input<ButtonLinkConfig | null>(null);
  mixpanelClickEvent = input<MixPanelEvent | null>(null);
  customRightWidget = input(false);
}
